import React from 'react';
import { Chip } from '@biq/apex-ui';

interface ChipProps {
    label: string;
    color:
        | 'primary'
        | 'default'
        | 'secondary'
        | 'error'
        | 'info'
        | 'success'
        | 'warning'
        | 'grayscale';
    readOnly: boolean;
    icon?: React.ReactElement;
    variant: 'filled' | 'outlined';
    onDelete?: () => void;
    onClick?: () => void;
    chipStyles?: any;
    isMultiLineChip?: boolean;
}

const styles = {
    chipStyles: {
        height: 'fit-content',
        '& .MuiChip-label': {
            position: 'relative',
            '& .ellipsis-icon': {
                display: 'inline-block',
                width: '24px',
                height: '16px',
                position: 'relative',
                verticalAlign: 'middle',
                bottom: '1px',
            },
        },
    },
};

const chipMutliLineStyles = {
    '& .MuiChip-label': {
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textWrap: 'wrap',
    },
};

export const TruncateChip = ({
    label = '',
    chipStyles = {},
    color = 'primary',
    readOnly = true,
    icon,
    variant = 'filled',
    onClick,
    onDelete,
    isMultiLineChip = false,
}: ChipProps): JSX.Element => {
    return (
        <Chip
            label={label}
            size='small'
            variant={variant}
            sx={{
                ...styles.chipStyles,
                ...chipStyles,
                ...(isMultiLineChip && chipMutliLineStyles),
            }}
            onDelete={onDelete}
            onClick={onClick}
            color={color}
            icon={icon}
            readOnly={readOnly}
        />
    );
};
